import React from 'react';
import { Hero } from '../components/hero/Hero';
import { ProofStrip } from '../components/sections/ProofStrip';
import { ManufacturerStrip } from '../components/sections/ManufacturerStrip';
import { WelcomeVideo } from '../components/sections/WelcomeVideo';
import { FeaturedModality } from '../components/sections/FeaturedModality';
import { Categories } from '../components/sections/Categories';
import { Process } from '../components/sections/Process';
import { UsedEquipment } from '../components/sections/UsedEquipment';
import { ProductDepth } from '../components/sections/ProductDepth';
import { ConciergeSuite } from '../components/sections/ConciergeSuite';
import { Testimonial } from '../components/sections/Testimonial';
export function Home() {
  return <>
      <Hero data-id="element-571" data-mp="2dfdthvpfawua" />
      <ManufacturerStrip data-id="element-572" data-mp="3kvk62l8hf36i" />
      <WelcomeVideo data-id="element-573" data-mp="3kw21xgr8ffdw" />
      <FeaturedModality data-id="element-574" data-mp="3kuqv182hprik" />
      <Categories data-id="element-575" data-mp="3kxd63holap5j" />
      <Process data-id="element-576" data-mp="3owlvkaclk0va" />
      <UsedEquipment data-id="element-577" data-mp="3owcdd8xsmy05" />
      <ProductDepth data-id="element-578" data-mp="3ovkiy1fxn6bg" />
      <ConciergeSuite data-id="element-579" data-mp="3ov2ggn2ofvv3" />
      <Testimonial data-id="element-580" data-mp="30wrpwio1y1gl" />
      <ProofStrip data-id="element-581" data-mp="30xb9s4x9izx9" />
    </>;
}